<template lang="pug">
article.company(:class="{ 'is-board': $route.meta.board }")
  header.company-header
    .max-width
      .row.main-row.apart.center
        .col
          .row.gap-2.center
            .col
              h1
                router-link.logo(:to="{ name: 'PublicDashboard' }")
                  img.logo-horizontal(
                    v-if="company.logoUrl",
                    :src="company.logoUrl"
                  )
                  span {{ company.name }}
            .col(v-if="company.beta && company.beta.changelog")
              router-link(:to="{ name: 'PublicChangelog' }") Changelogs
        .col.right
          .row.center.gap-1(v-if="user.isAuthenticated")
            .col.admin-toggle(v-if="company.isMember")
              router-link.header-link(
                v-if="$route.name === 'AdminDashboard'",
                :to="{ name: 'PublicDashboard' }"
              ) Public View
              router-link.header-link(
                v-if="$route.name === 'PublicDashboard'",
                :to="{ name: 'AdminDashboard' }"
              ) Admin View

              router-link.header-link(
                v-if="$route.name === 'AdminBoard'",
                :to="{ name: 'PublicBoard' }"
              ) Public View
              router-link.header-link(
                v-if="$route.name === 'PublicBoard'",
                :to="{ name: 'AdminBoard' }"
              ) Admin View

              router-link.header-link(
                v-if="$route.name === 'AdminFeature'",
                :to="{ name: 'PublicFeature' }"
              ) Public View
              router-link.header-link(
                v-if="$route.name === 'PublicFeature'",
                :to="{ name: 'AdminFeature' }"
              ) Admin View
            .col
              UserNotifications
            .col
              DropdownMenu(type="header")
                template(slot="toggle")
                  UserAvatar(:user="user", size="header")
                template(slot="menu")
                  .list-menu(v-if="company.isMember")
                    router-link.list-item(:to="{ name: 'SettingsAccount' }") Settings
                  .list-menu(v-else)
                    router-link.list-item(
                      :to="{ name: 'UserSettingsAccount' }"
                    ) Settings
                  .list-menu
                    .list-item(@click="logout") Logout
            .col.create-feature(v-if="$route.meta.board")
              router-link.button.primary-button(
                :to="{ name: 'CreateFeature' }"
              )
                font-awesome-icon(:icon="['fas', 'plus']")
          .row.center.gap-1(v-else)
            .col
              .header-link(@click="openModal(LoginForm)") Login
            .col
              .header-link(@click="openModal(RegisterForm)") Sign Up
  .page
    router-view

  ModalOverlay(:open="showModal", @close="closeModal")
    component(:is="modalComponent", @close="closeModal", @swap="swapModal")
</template>

<script>

import EventBus from '@/plugins/vue-event-bus'

import { mapState } from 'vuex'
import ModalOverlay from '@/components/helpers/ModalOverlay'
import RegisterForm from '@/components/auth/RegisterForm'
import LoginForm from '@/components/auth/LoginForm'

import UserNotifications from '@/components/notifications/UserNotifications'

export default {
  name: 'Company',
  components: {
    ModalOverlay,
    RegisterForm,
    LoginForm,
    UserNotifications
  },
  data() {
    return {
      modalComponent: null,
      showModal: false,
      RegisterForm,
      LoginForm,
    }
  },
  created() {
    EventBus.$on('auth:showSignUp', () => {
      this.openModal(RegisterForm)
    })
    //console.log(this.$route)
  },
  beforeMount() {
    this.$store.dispatch('user/authenticate')
    this.$store.dispatch('getCompany').then(company => {
        EventBus.$emit('subscribe-company', company);
    });
    this.$store.dispatch('boards/getBoards')
    this.$store.dispatch('getStatuses')
  },
  mounted () {
  },
  computed: {
    ...mapState({
      company: state => state.company,
      user: state => state.user
    })
  },
  methods: {
    logout() {
      this.$store.dispatch('user/logout')
      .then(() => {
        if (this.$route.name !== 'PublicDashboard') {
          this.$router.push({ name: 'PublicDashboard' })
        } else {
          this.closeModal()
        }
      })
    },
    openModal(modal) {
      this.modalComponent = modal
      this.showModal = true
    },
    closeModal(modal) {
      this.showModal = false
    },
    swapModal(modal) {
      this.modalComponent = this[modal]
    }
  }
}

</script>

<style lang="stylus" scoped>
  .company-header
    .logo
      color $text-default
      font-size 18px
    .logo-horizontal
      height 50px
      margin-right $spacing
      vertical-align middle
      +for_breakpoint(mobile)
        display none

    .header-link
      cursor pointer
      display inline-block

    .header-link + .header-link
      margin-left $spacing-2

    .create-feature
      +for_breakpoint(desktop)
        display none

    .admin-toggle
      +for_breakpoint(mobile)
        display none
</style>
